(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-collection-filters"] && !Shopify.designMode) return;
  try {
    class PPLiveCollection {
  static groups=['blomfarg','hojd','anvandning','sadd','month','lage','availability'];
  static values={blomfarg:['Vit','Kräm','Gul','Aprikos','Rosa','Röd','Vinröd','Lila','Blå','Grön','Brun','Silver','Bladgrönt','Orange'],hojd:['Låg, under 40 cm','Medelhög, 40–80 cm','Hög, över 80 cm'],anvandning:['Snitt & bukett','Rabatt','Kruka & balkong','Torkning','Pollinatörer','Spaljé & klättring','Utfyllnad'],sadd:['Förodling','Direktsådd','Höstsådd','Kallsådd'],lage:['Sol','Halvskugga','Skugga'],month:Array.from({length:12},(_,i)=>String(i+1)),availability:['1','0']};
  static months=['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'];
  static colours=['#fff','#f4e9c6','#efd36d','#e8b094','#ebb4c6','#b7434b','#702c47','#9771a5','#9ab5cc','#a5af81','#987762','#c5c9c5','#779069','#e8914c'];
  static match(p,s){
    if(s.availability.length&&!s.availability.includes(p.available?'1':'0'))return false;
    if(p.flower_eligible===false)return s.mixes&&!PPLiveCollection.groups.some(key=>key!=='availability'&&s[key].length);
    if(!s.mixes&&p.fargblandning)return false;
    for(const key of ['blomfarg','hojd','anvandning','lage'])if(s[key].length&&!s[key].some(v=>p[key].includes(v)))return false;
    if(s.month.length)return p.windows.some(w=>(!s.sadd.length||s.sadd.includes(w.method))&&s.month.some(m=>w.months.includes(Number(m))));
    return !s.sadd.length||s.sadd.some(v=>p.sadd.includes(v));
  }
  static plainLabels(labels){
    const decoder=document.createElement('textarea');
    const decode=value=>{
      if(typeof value==='string')return value.replace(/&(?:amp|lt|gt|quot|apos|#\d+|#x[\da-f]+);/gi,entity=>{decoder.innerHTML=entity;return decoder.value;});
      if(Array.isArray(value))return value.map(decode);
      if(value&&typeof value==='object')return Object.fromEntries(Object.entries(value).map(([key,text])=>[key,decode(text)]));
      return value;
    };
    return decode(labels);
  }
  constructor(component){this.c=component;this.sort=null;this.products=null;this.cards=new Map();this.state=this.readState(new URL(location.href));}
  start(){
    const c=this.c;
    const initial=document.querySelector('#CollectionProductGrid [data-ppcf-data]');
    try{this.labels=PPLiveCollection.plainLabels(JSON.parse(initial?.textContent||'null')?.labels);}catch{}
    this.loadingFields();
    c.addEventListener('click',event=>{
      const button=event.target.closest('[data-ppcf-this-month]');if(!button)return;
      const month=new Intl.DateTimeFormat('en',{timeZone:'Europe/Stockholm',month:'numeric'}).format(new Date());
      const state={...this.state,month:[month],page:1};this.navigate(this.urlFor(state));
    },{signal:c.abort.signal});
    document.addEventListener('click',event=>{
      const link=event.target.closest('#CollectionProductGrid [data-ppcf-page]');if(!link||!this.products)return;
      if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();event.stopPropagation();this.navigate(new URL(link.href));
      c.scrollIntoView({block:'start',behavior:'smooth'});
    },{capture:true,signal:c.abort.signal});
    if(PPLiveCollection.groups.some(k=>this.state[k].length)||!this.state.mixes||new URL(location.href).searchParams.has('ppf_page'))this.navigate(new URL(location.href),false);
  }
  element(tag,className,text){const el=document.createElement(tag);if(className)el.className=className;if(text!==undefined)el.textContent=text;return el;}
  loadingFields(){const field=this.c.querySelector('[data-ppcf-fields]');field.replaceChildren(this.element('p','ppcf__help',this.labels?.ui.loading||this.c.dataset.loading));}
  readState(url){
    const state={mixes:url.searchParams.get('ppf_mixes')!=='0',page:Math.max(1,parseInt(url.searchParams.get('ppf_page')||url.searchParams.get('page')||'1',10)||1),sort:url.searchParams.get('sort_by')||this.c.querySelector('[data-ppcf-sort]')?.value||''};
    for(const key of PPLiveCollection.groups)state[key]=[...new Set(url.searchParams.getAll('ppf_'+key))].filter(v=>PPLiveCollection.values[key].includes(v));
    if(!state.availability.length)state.availability=url.searchParams.getAll('filter.v.availability').filter(v=>['0','1'].includes(v));
    return state;
  }
  urlFor(state){
    const url=this.c.safeUrl(location.href);
    for(const key of [...url.searchParams.keys()])if(key.startsWith('ppf_')||key.startsWith('filter.')||key==='page'||key==='sort_by')url.searchParams.delete(key);
    for(const key of PPLiveCollection.groups)for(const value of state[key])url.searchParams.append('ppf_'+key,value);
    if(!state.mixes)url.searchParams.set('ppf_mixes','0');
    if(state.page>1)url.searchParams.set('ppf_page',String(state.page));
    if(state.sort)url.searchParams.set('sort_by',state.sort);
    return url;
  }
  formUrl(){
    if(!this.products)return this.c.safeUrl(location.href);
    const state={...this.state,page:1,sort:this.c.querySelector('[data-ppcf-sort]')?.value||this.state.sort,mixes:this.c.querySelector('[name=ppf_mixes]')?.checked??true};
    for(const key of PPLiveCollection.groups)state[key]=[...this.c.querySelectorAll('input[name="ppf_'+key+'"]:checked')].map(i=>i.value);
    return this.urlFor(state);
  }
  reset(){const state={...this.state,page:1,mixes:true};for(const key of PPLiveCollection.groups)state[key]=[];this.navigate(this.urlFor(state));}
  load(){if(!this.products&&!this.c.pending)this.navigate(new URL(location.href),false);}
  label(key,value){if(key==='month')return this.labels.months[Number(value)-1];if(key==='availability')return this.labels.ui[value==='1'?'available':'unavailable'];return this.labels.values[key][PPLiveCollection.values[key].indexOf(value)]||value;}
  normalizeState(state){
    let changed=false;
    for(const key of ['month','lage'])if(!this.capabilities[key]&&state[key].length){state[key]=[];changed=true;}
    if(!this.capabilities.mixes&&!state.mixes){state.mixes=true;changed=true;}
    if(changed)state.page=1;
    return changed;
  }
  showResetNotice(show){
    let notice=this.c.querySelector('[data-ppcf-optional-reset]');
    if(!notice){notice=this.element('p','ppcf__help');notice.dataset.ppcfOptionalReset='';notice.setAttribute('role','status');this.c.querySelector('[data-ppcf-chips]').after(notice);}
    notice.textContent=this.labels.ui.optional_filters_removed||'';notice.hidden=!show;
  }
  showMixedScopeNotice(){
    let notice=this.c.querySelector('[data-ppcf-mixed-scope]');
    if(!notice&&!this.mixedScope)return;
    if(!notice){notice=this.element('p','ppcf__help');notice.dataset.ppcfMixedScope='';this.c.querySelector('[data-ppcf-chips]').after(notice);}
    notice.textContent=this.labels.ui.mixed_scope_help||'';notice.hidden=!this.mixedScope;
  }
  async fetchAll(url,signal){
    const base=this.c.safeUrl(url);
    for(const key of [...base.searchParams.keys()])if(key.startsWith('ppf_')||key.startsWith('filter.')||key==='page')base.searchParams.delete(key);
    base.searchParams.set('section_id',this.c.dataset.section);
    const products=[],cards=new Map();let first;
    const fetchPage=async page=>{
      if(signal.aborted)throw new DOMException('Aborted','AbortError');
      const request=new URL(base);request.searchParams.set('page',String(page));
      const response=await fetch(request.toString(),{signal,cache:'no-store',headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error('Collection request failed');
      const template=document.createElement('template');template.innerHTML=await response.text();
      const grid=template.content.querySelector('#CollectionProductGrid');const raw=grid?.querySelector('[data-ppcf-data]');
      if(!raw)throw new Error('Missing collection data');
      const data=JSON.parse(raw.textContent);
      if(data.collection!==this.c.dataset.collection||data.section!==this.c.dataset.section||data.page!==page||!Number.isInteger(data.total)||data.total<0||data.total!==data.unfiltered||!Number.isInteger(data.pages)||data.pages<0||data.pages>60||!Number.isInteger(data.size)||data.size<1||!Array.isArray(data.products)||data.products.length>data.size)throw new Error('Incomplete collection');
      if(first&&(data.total!==first.total||data.pages!==first.pages||data.size!==first.size||data.sort!==first.sort))throw new Error('Collection changed while loading');
      return {data,grid};
    };
    const pages=[await fetchPage(1)];first=pages[0].data;
    const pageCount=Math.max(1,first.pages);let nextPage=2,failed=false;
    const worker=async()=>{
      while(!failed&&nextPage<=pageCount){
        const page=nextPage++;
        try{pages[page-1]=await fetchPage(page);}catch(error){failed=true;throw error;}
      }
    };
    await Promise.all(Array.from({length:Math.min(3,pageCount-1)},()=>worker()));
    let completeLocation=true,completeMixes=true,completeCalendar=true,eligibleCount=0;
    for(const {data,grid} of pages){
      for(const source of data.products){
        const p={...source};
        if(!/^\d+$/.test(p.id)||cards.has(p.id)||typeof p.available!=='boolean'||typeof p.flower_eligible!=='boolean')throw new Error('Invalid product');
        if(p.flower_eligible){
          eligibleCount++;
          for(const key of ['blomfarg','hojd','anvandning','sadd'])if(!Array.isArray(p[key])||!p[key].length||p[key].some(v=>!PPLiveCollection.values[key].includes(v)))throw new Error('Missing approved fields');
          const validLocation=Array.isArray(p.lage)&&p.lage.length>0&&p.lage.every(v=>PPLiveCollection.values.lage.includes(v));
          completeLocation=completeLocation&&validLocation;if(!validLocation)p.lage=[];
          completeMixes=completeMixes&&typeof p.fargblandning==='boolean';
          const windows=Array.isArray(p.windows)?p.windows:[];
          p.windows=windows.flatMap(w=>{
            if(!w||!p.sadd.includes(w.method))return [];
            const months=w.months===null?[]:w.months;
            if(w.product!==p.id||!Array.isArray(months)||months.some(m=>!PPLiveCollection.months.includes(m))||typeof w.conditions!=='string'||!w.conditions.trim())return [];
            return [{...w,months:months.map(m=>PPLiveCollection.months.indexOf(m)+1)}];
          });
          completeCalendar=completeCalendar&&p.sadd.every(method=>p.windows.some(w=>w.method===method));
        }else{
          for(const key of ['blomfarg','hojd','anvandning','sadd','lage'])p[key]=[];
          p.fargblandning=null;p.windows=[];
        }
        const card=grid.querySelector('[data-ppcf-product-id="'+p.id+'"]');
        if(!card||card.parentElement?.id!=='template--collection')throw new Error('Missing native product card');
        products.push(p);cards.set(p.id,card.outerHTML);
      }
    }
    if(products.length!==first.total||cards.size!==first.total)throw new Error('Missing collection pages');
    const capabilities={lage:eligibleCount>0&&completeLocation,mixes:eligibleCount>0&&completeMixes,month:eligibleCount>0&&completeCalendar};
    return {products,cards,capabilities,mixedScope:eligibleCount<products.length,labels:PPLiveCollection.plainLabels(first.labels),size:first.size,sort:first.sort};
  }
  async navigate(url,push=true){
    const c=this.c,state=this.readState(url),sequence=++c.sequence;
    c.request?.abort();c.request=new AbortController();c.pending=true;c.failedUrl=null;c.apply.disabled=true;c.setAttribute('aria-busy','true');
    c.querySelectorAll('[data-ppcf-error]').forEach(e=>e.hidden=true);
    const grid=document.getElementById('CollectionProductGrid');grid?.setAttribute('aria-busy','true');
    c.confirmedApplyText=c.confirmedApplyText||c.apply.textContent;c.apply.textContent=c.dataset.loading;
    const controller=c.request;const timer=setTimeout(()=>controller.abort(),30000);
    try{
      let refreshFields=false;
      if(!this.products||this.sort!==state.sort){
        const result=await this.fetchAll(url,c.request.signal);
        if(sequence!==c.sequence)return;
        Object.assign(this,result);state.sort=this.sort;refreshFields=true;
      }
      if(sequence!==c.sequence)return;
      const resetOptional=this.normalizeState(state);
      this.state=state;if(refreshFields)this.renderFields();this.renderResults();
      const finalUrl=this.urlFor(this.state);if(finalUrl.toString()!==location.href){if(push)history.pushState({ppCollectionFilters:true},'',finalUrl);else if(resetOptional)history.replaceState({ppCollectionFilters:true},'',finalUrl);}
      this.updateControls();this.showResetNotice(resetOptional);this.showMixedScopeNotice();
    }catch(error){
      if(sequence===c.sequence){controller.abort();c.failedUrl=url;c.querySelectorAll('[data-ppcf-error]').forEach(e=>e.hidden=false);if(!this.products)this.c.querySelector('[data-ppcf-fields]').replaceChildren(this.element('p','ppcf__help',this.labels?.ui.incomplete||this.c.dataset.loading));}
    }finally{
      clearTimeout(timer);if(sequence===c.sequence){c.pending=false;c.apply.disabled=false;c.apply.textContent=c.confirmedApplyText;c.removeAttribute('aria-busy');grid?.removeAttribute('aria-busy');}
    }
  }
  renderFields(){
    const c=this.c,container=c.querySelector('[data-ppcf-fields]'),opened=new Set([...container.querySelectorAll('details[open]')].map(d=>d.dataset.group));
    const fragment=document.createDocumentFragment();
    if(this.mixedScope){const help=this.element('p','ppcf__help',this.labels.ui.mixed_scope_help||'');help.dataset.ppcfMixedScopePanel='';fragment.append(help);}
    for(const key of PPLiveCollection.groups){
      if(['month','lage'].includes(key)&&!this.capabilities[key])continue;
      const group=this.element('details','ppcf__group');group.dataset.group=key;group.open=opened.has(key);
      const summary=this.element('summary',null,this.labels.groups[key]);const plus=this.element('span',null,'+');plus.setAttribute('aria-hidden','true');summary.append(plus);group.append(summary);
      const fieldset=this.element('fieldset');fieldset.append(this.element('legend','ppcf__sr-only',this.labels.groups[key]));
      if(key==='month'){
        const button=this.element('button','ppcf__button ppcf__month',this.labels.ui.this_month);button.type='button';button.dataset.ppcfThisMonth='';fieldset.append(button,this.element('p','ppcf__help',this.labels.ui.sowing_help));
      }
      if(key==='sadd'&&this.products.some(p=>p.sadd.some(method=>['Höstsådd','Kallsådd'].includes(method))))fieldset.append(this.element('p','ppcf__help',this.labels.ui.method_help));
      for(const value of PPLiveCollection.values[key]){
        const selected=this.state[key].includes(value);
        if(!['month','sadd','availability'].includes(key)&&!selected&&!this.products.some(p=>p[key].includes(value)))continue;
        const label=this.element('label','ppcf__option'),input=this.element('input');input.type='checkbox';input.name='ppf_'+key;input.value=value;label.append(input);
        if(key==='blomfarg'){const swatch=this.element('span','ppcf__swatch');swatch.style.background=PPLiveCollection.colours[PPLiveCollection.values.blomfarg.indexOf(value)];swatch.setAttribute('aria-hidden','true');label.append(swatch);}
        label.append(this.element('span',null,this.label(key,value)));const count=this.element('span','ppcf__option-count');count.dataset.ppcfOptionCount='';label.append(count);fieldset.append(label);
      }
      if(key==='blomfarg'&&this.capabilities.mixes){
        const label=this.element('label','ppcf__option ppcf__mixes'),input=this.element('input');input.type='checkbox';input.name='ppf_mixes';input.value='1';label.append(input,this.element('span',null,this.labels.ui.include_mixes));fieldset.append(label);
      }
      group.append(fieldset);fragment.append(group);
    }
    container.replaceChildren(fragment);
  }
  updateControls(){
    const c=this.c,s=this.state;
    for(const key of PPLiveCollection.groups){
      for(const input of c.querySelectorAll('input[name="ppf_'+key+'"]')){
        input.checked=s[key].includes(input.value);
        const count=this.products.filter(p=>PPLiveCollection.match(p,{...s,[key]:[input.value]})).length;
        input.disabled=count===0&&!input.checked;input.closest('label').querySelector('[data-ppcf-option-count]').textContent=String(count);
      }
    }
    const mixes=c.querySelector('[name=ppf_mixes]');if(mixes)mixes.checked=s.mixes;
    const sort=c.querySelector('[data-ppcf-sort]');if(sort)sort.value=s.sort;
    const chips=c.querySelector('[data-ppcf-chips]');chips.replaceChildren();let active=0;
    for(const key of PPLiveCollection.groups)for(const value of s[key]){
      active++;const text=this.labels.groups[key]+': '+this.label(key,value),link=this.element('a','ppcf__chip',text+' ×');
      link.href=this.urlFor({...s,[key]:s[key].filter(v=>v!==value),page:1}).toString();link.dataset.ppcfRemove='';link.setAttribute('aria-label',this.labels.ui.remove.replace('{value}',text));chips.append(link);
    }
    if(!s.mixes){active++;const link=this.element('a','ppcf__chip',this.labels.ui.no_mixes+' ×');link.href=this.urlFor({...s,mixes:true,page:1}).toString();link.dataset.ppcfRemove='';chips.append(link);}
    c.querySelector('[data-ppcf-active]').textContent=active?'('+active+')':'';
    c.querySelector('[data-ppcf-count]').textContent=this.countText('count',this.matches.length);
    c.dataset.count=String(this.matches.length);c.confirmedApplyText=this.countText('show',this.matches.length);
  }
  countText(key,count){return count===1?this.labels.ui[key+'_one']:this.labels.ui[key].replace('{count}',String(count));}
  renderResults(){
    const grid=document.getElementById('CollectionProductGrid'),body=grid?.querySelector('#template--collection');if(!body)throw new Error('Missing native grid');
    this.matches=this.products.filter(p=>PPLiveCollection.match(p,this.state));const pages=Math.max(1,Math.ceil(this.matches.length/this.size));this.state.page=Math.min(this.state.page,pages);
    const fragment=document.createDocumentFragment();
    for(const p of this.matches.slice((this.state.page-1)*this.size,this.state.page*this.size)){
      const template=document.createElement('template');template.innerHTML=this.cards.get(p.id);const card=template.content.firstElementChild;
      card.classList.remove('show-on-scroll');card.querySelectorAll('.show-on-scroll').forEach(el=>el.classList.remove('show-on-scroll'));
      card.querySelectorAll('[data-animate]').forEach(el=>el.removeAttribute('data-animate'));
      if(p.fargblandning===true)card.append(this.element('span','ppcf__mix-badge',this.labels.ui.mix));
      if(this.state.month.length){
        const box=this.element('div','ppcf__conditions');
        for(const w of p.windows){const months=w.months.filter(m=>this.state.month.includes(String(m)));if(!months.length||(this.state.sadd.length&&!this.state.sadd.includes(w.method)))continue;
          const line=this.element('p');line.append(this.element('strong',null,this.label('sadd',w.method)+' · '+months.map(m=>this.labels.months[m-1]).join(', ')),document.createTextNode(' — '+w.conditions));box.append(line);
        }
        card.append(box);
      }
      fragment.append(card);
    }
    if(!this.matches.length){const empty=this.element('div','ppcf__empty');empty.setAttribute('role','status');empty.append(this.element('p',null,this.labels.ui.empty_title),this.element('p',null,this.labels.ui.empty_body));fragment.append(empty);}
    body.replaceChildren(fragment);grid.querySelectorAll('.pagination,.pagination-loading,.ppcf__pages').forEach(el=>el.remove());
    if(pages>1){const nav=this.element('nav','ppcf__pages');nav.setAttribute('aria-label',this.labels.ui.page.replace('{page}',String(this.state.page)).replace('{pages}',String(pages)));
      for(let page=1;page<=pages;page++){const link=this.element('a','ppcf__button',String(page));link.dataset.ppcfPage=String(page);link.href=this.urlFor({...this.state,page}).toString();if(page===this.state.page)link.setAttribute('aria-current','page');nav.append(link);}grid.append(nav);
    }
    document.dispatchEvent(new CustomEvent('paginate'));window.dispatchEvent(new Event('scroll'));
    if(window.eventBus)window.eventBus.emit('collection:filters:change',{details:{parameters:this.urlFor(this.state).searchParams.toString()}});
  }
}

if (!customElements.get('pp-collection-filters')) {
  customElements.define('pp-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized=true;this.sequence=0;this.abort=new AbortController();
      const signal=this.abort.signal;
      this.dialog=this.querySelector('dialog');this.form=this.querySelector('form');this.opener=this.querySelector('[data-ppcf-open]');this.apply=this.querySelector('[data-ppcf-apply]');
      this.addEventListener('click',event=>{
        const target=event.target.closest('button,a');if(!target)return;
        if(target.matches('[data-ppcf-open]'))this.open();
        if(target.matches('[data-ppcf-close]'))this.close();
        if(target.matches('[data-ppcf-reset]')){event.preventDefault();if(this.live){this.live.reset();return;}this.form.querySelectorAll('input[type=checkbox]').forEach(i=>i.checked=false);this.navigate(this.formUrl());}
        if(target.matches('[data-ppcf-remove]')){event.preventDefault();this.navigate(this.safeUrl(target.href));}
        if(target.matches('[data-ppcf-retry]'))this.navigate(this.failedUrl||this.formUrl());
      },{signal});
      this.addEventListener('change',event=>{if(event.target.matches('input,select'))this.navigate(this.formUrl());},{signal});
      this.form.addEventListener('submit',event=>{event.preventDefault();if(!this.pending&&!this.failedUrl)this.close();else if(this.failedUrl)this.navigate(this.formUrl());},{signal});
      this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();},{signal});
      this.dialog.addEventListener('click',event=>{const r=this.dialog.getBoundingClientRect();if(event.target===this.dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))this.close();},{signal});
      window.addEventListener('popstate',()=>{this.close();this.navigate(new URL(location.href),false);},{signal});
      this.refreshCount();this.decorateLinks();
      if(this.dataset.live==='true'){this.live=new PPLiveCollection(this);this.live.start();}
    }
    open(){if(this.dialog.open)return;this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();this.opener.setAttribute('aria-expanded','true');this.querySelector('[data-ppcf-close]').focus();this.live?.load();}
    close(restore=true){if(!this.dialog?.open)return;this.dialog.close();document.documentElement.style.overflow=this.previousOverflow||'';this.opener.setAttribute('aria-expanded','false');if(restore&&this.opener.isConnected)this.opener.focus();}
    safeUrl(href){const url=new URL(href,location.href);if(url.origin!==location.origin||url.pathname!==location.pathname)throw new Error('Wrong collection');url.searchParams.delete('section_id');url.searchParams.delete('sections');for(const key of ['preview_theme_id','view'])if(!url.searchParams.has(key)&&new URL(location.href).searchParams.has(key))url.searchParams.set(key,new URL(location.href).searchParams.get(key));return url;}
    formUrl(){if(this.live)return this.live.formUrl();const url=this.safeUrl(location.href);for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.')||key==='page'||key==='sort_by')url.searchParams.delete(key);for(const [key,value] of new FormData(this.form))if(value&&(key.startsWith('filter.')||key==='sort_by'))url.searchParams.append(key,value);const sort=this.querySelector('[data-ppcf-sort]');if(sort)url.searchParams.set('sort_by',sort.value);return url;}
    async navigate(url,push=true){
      if(this.live)return this.live.navigate(url,push);
      const current=++this.sequence;this.request?.abort();this.request=new AbortController();this.pending=true;this.failedUrl=null;this.apply.disabled=true;this.setAttribute('aria-busy','true');this.querySelectorAll('[data-ppcf-error]').forEach(e=>e.hidden=true);
      this.confirmedApplyText=this.confirmedApplyText||this.apply.textContent;this.apply.textContent=this.dataset.loading;
      const focus=document.activeElement;const focusKey=focus?.name?{name:focus.name,value:focus.value}:null;
      const grid=document.getElementById('CollectionProductGrid');grid?.setAttribute('aria-busy','true');
      const fetchUrl=new URL(url);fetchUrl.searchParams.set('section_id',this.dataset.section);
      try{
        const response=await fetch(fetchUrl.toString(),{signal:this.request.signal,headers:{'Accept':'text/html'}});if(!response.ok)throw new Error('Request failed');
        const parsed=new DOMParser().parseFromString(await response.text(),'text/html');if(current!==this.sequence)return;
        const next=parsed.querySelector('pp-collection-filters');const nextGrid=parsed.getElementById('CollectionProductGrid');
        if(!next||!nextGrid||next.dataset.collection!==this.dataset.collection||next.dataset.section!==this.dataset.section)throw new Error('Wrong response');
        const replacements=['[data-ppcf-fields]','[data-ppcf-chips]','[data-ppcf-count]'].map(selector=>({from:next.querySelector(selector),to:this.querySelector(selector)}));
        const nextApply=next.querySelector('[data-ppcf-apply]');
        if(!grid||!nextApply||!/^\d+$/.test(next.dataset.count)||replacements.some(pair=>!pair.from||!pair.to))throw new Error('Missing filters');
        const opened=new Set([...this.querySelectorAll('[data-group][open]')].map(d=>d.dataset.group));
        for(const {from,to} of replacements)to.innerHTML=from.innerHTML;
        this.querySelectorAll('[data-group]').forEach(d=>d.open=opened.has(d.dataset.group));
        this.dataset.count=next.dataset.count;this.confirmedApplyText=nextApply.textContent;
        const sort=this.querySelector('[data-ppcf-sort]'),nextSort=next.querySelector('[data-ppcf-sort]');if(sort&&nextSort)sort.value=nextSort.value;
        grid.innerHTML=nextGrid.innerHTML;
        if(push&&url.toString()!==location.href)history.pushState({ppCollectionFilters:true},'',url);
        this.refreshCount();this.decorateLinks();
        document.dispatchEvent(new CustomEvent('paginate'));
        window.dispatchEvent(new Event('scroll'));
        if(window.eventBus)window.eventBus.emit('collection:filters:change',{details:{parameters:url.searchParams.toString()}});
        if(this.dialog.open&&focusKey){const replacement=[...this.querySelectorAll('input,select')].find(i=>i.name===focusKey.name&&i.value===focusKey.value);if(replacement&&!replacement.disabled)replacement.focus();else this.querySelector('[data-ppcf-close]').focus();}
        else if(focus&&!focus.isConnected)this.opener.focus();
      }catch(error){if(current===this.sequence&&error.name!=='AbortError'){this.failedUrl=url;this.querySelectorAll('[data-ppcf-error]').forEach(e=>e.hidden=false);}}
      finally{if(current===this.sequence){this.pending=false;this.apply.disabled=false;this.apply.textContent=this.confirmedApplyText;this.removeAttribute('aria-busy');grid?.removeAttribute('aria-busy');}}
    }
    refreshCount(){const count=Number(this.querySelector('[data-ppcf-active-total]')?.dataset.ppcfActiveTotal||0);this.querySelector('[data-ppcf-active]').textContent=count?'('+count+')':'';}
    decorateLinks(){document.querySelectorAll('#CollectionProductGrid .pagination a[href]').forEach(a=>{try{a.href=this.safeUrl(a.href).toString();}catch{}});}
    disconnectedCallback(){this.sequence++;this.request?.abort();this.abort?.abort();this.close(false);this.initialized=false;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-mobile-discount"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-mobile-discount')) {
    customElements.define('pp-mobile-discount', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.bound = new WeakSet();
        this.viewport = window.visualViewport;
        this.watchWidget = this.watchWidget.bind(this);
        this.updateEditing = this.updateEditing.bind(this);
        const options = { signal: this.controller.signal };
        document.addEventListener('focusin', this.updateEditing, options);
        document.addEventListener('focusout', () => queueMicrotask(this.updateEditing), options);
        this.viewport?.addEventListener('resize', this.updateEditing, options);
        window.addEventListener('resize', this.updateEditing, options);
        this.updateEditing();
        this.watchWidget();
        if (!this.widget) {
          this.waiting = new MutationObserver(this.watchWidget);
          this.waiting.observe(document.body, { childList: true });
        }
      }

      updateEditing() {
        const active = document.activeElement;
        const editing = Boolean(active?.matches('textarea, select, [contenteditable="true"], input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="range"]):not([type="hidden"])'));
        const keyboard = this.viewport && this.viewport.scale <= 1.05 && window.innerHeight - this.viewport.height > 140;
        document.documentElement.toggleAttribute('data-pp-discount-editing', editing || Boolean(keyboard));
      }

      watchWidget() {
        const widget = document.getElementById('ecomsend-widget');
        if (!widget) return;
        this.waiting?.disconnect();
        this.widget = widget;
        this.enhance();
        if (!this.observer) {
          this.observer = new MutationObserver(() => this.enhance());
          this.observer.observe(widget, { childList: true, subtree: true });
        }
      }

      enhance() {
        this.widget.querySelectorAll('.ecomsend__Popover__Widget__CustomContainer').forEach(container => {
          const text = container.querySelector('.ecomsend__Popover__Widget__Text');
          const close = container.querySelector(':scope > svg');
          if (text) this.makeKeyboardAction(text);
          if (close) {
            close.setAttribute('aria-label', this.dataset.closeLabel);
            this.makeKeyboardAction(close);
          }
        });
      }

      makeKeyboardAction(element) {
        if (this.bound.has(element)) return;
        this.bound.add(element);
        element.setAttribute('role', 'button');
        element.setAttribute('tabindex', '0');
        element.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          element.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.waiting?.disconnect();
        this.observer?.disconnect();
        this.waiting = null;
        this.observer = null;
        this.widget = null;
        document.documentElement.removeAttribute('data-pp-discount-editing');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-search-panel')) {
  customElements.define('pp-search-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.events = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.results = this.querySelector('[data-pps-results]');
      this.start = this.querySelector('[data-pps-start]');
      this.footer = this.querySelector('[data-pps-footer]');
      this.status = this.querySelector('[data-pps-status]');
      this.hint = this.querySelector('#PPSearchHint');
      this.scroller = this.querySelector('.pps__scroll');
      this.feedback = this.querySelector('[data-pps-feedback]');
      this.fallback = this.querySelector('[data-pps-fallback]');
      this.clear = this.querySelector('[data-pps-clear]');
      this.sequence = 0;
      const on = (node, name, fn, capture=false) => node.addEventListener(name, fn, {capture, signal:this.events.signal});
      const viewportChanged = () => {
        if (!this.dialog.open) return;
        cancelAnimationFrame(this.viewportFrame);
        this.viewportFrame = requestAnimationFrame(() => this.updateViewport());
      };
      on(window, 'resize', viewportChanged);
      if (window.visualViewport) {
        on(window.visualViewport, 'resize', viewportChanged);
        on(window.visualViewport, 'scroll', viewportChanged);
      }
      on(document, 'click', event => {
        if (this.contains(event.target) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
        const opener = event.target.closest?.('[data-pp-search-open]');
        const field = this.externalInput(event.target) || this.externalInput(opener?.form?.querySelector('input[type="search"][name="q"]'));
        if (field) { event.preventDefault(); this.openField(field); return; }
        const trigger = event.target.closest?.('a[href]');
        if (!this.searchLink(trigger)) return;
        event.preventDefault(); event.stopImmediatePropagation(); this.open(trigger);
      }, true);
      on(document, 'input', event => {
        const field = this.externalInput(event.target);
        if (field && !event.isComposing) this.openField(field);
      });
      on(document, 'compositionend', event => {
        const field = this.externalInput(event.target);
        if (field) this.openField(field);
      });
      on(this.querySelector('[data-pps-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'close', () => {
        this.cancel(); document.documentElement.classList.remove('pps-open');
        this.unlockPage();
        if (this.sourceInput?.isConnected) this.sourceInput.value = this.input.value;
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
      });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      on(this.dialog, 'keydown', event => this.keydown(event));
      on(this.input, 'input', event => { if (!event.isComposing) this.queue(); });
      on(this.input, 'compositionstart', () => this.cancel());
      on(this.input, 'compositionend', () => this.queue());
      on(this.clear, 'click', () => { this.input.value=''; this.queue(); this.input.focus(); });
      on(this.form, 'submit', event => {
        this.input.value = this.input.value.trim();
        if (!this.input.value) { event.preventDefault(); this.input.focus(); return; }
        this.cancel();
      });
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) {
        const hidden=document.createElement('input'); hidden.type='hidden'; hidden.name='preview_theme_id'; hidden.value=preview; this.form.append(hidden);
      }
      this.observeToast = () => {
        const toast = document.querySelector('.pp-shopping-toast');
        if (!toast || this.toastObserver) return;
        this.toastObserver = new MutationObserver(() => {
          if (!this.dialog.open || toast.hidden || !toast.textContent.trim()) return;
          this.feedback.textContent = toast.textContent; this.feedback.hidden = false;
        });
        this.toastObserver.observe(toast,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['hidden']});
      };
      this.observeToast(); on(window, 'load', this.observeToast);
    }
    searchLink(link) {
      if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return false;
      try {
        const expected = new URL(this.form.action, location.href);
        const candidate = new URL(link.href, location.href);
        const sameRoute = candidate.origin === expected.origin && candidate.pathname.replace(/\/$/,'') === expected.pathname.replace(/\/$/,'');
        return sameRoute && [...candidate.searchParams].every(([key,value]) => key === 'preview_theme_id' || (key === 'q' && !value.trim()));
      } catch { return false; }
    }
    externalInput(element) {
      if (this.contains(element) || !element?.matches?.('input[type="search"][name="q"]') || !element.form) return null;
      try {
        const expected = new URL(this.form.action,location.href);
        const actual = new URL(element.form.action,location.href);
        return expected.origin === actual.origin && expected.pathname.replace(/\/$/,'') === actual.pathname.replace(/\/$/,'') ? element : null;
      } catch { return null; }
    }
    openField(field) {
      if (this.dialog.open || !this.dialog.showModal) return;
      const start=field.selectionStart, end=field.selectionEnd;
      this.input.value=field.value;
      this.open(field,field);
      if (start !== null && end !== null) this.input.setSelectionRange(start,end);
    }
    open(trigger,sourceInput=null) {
      this.sourceInput=sourceInput;
      this.trigger = trigger; trigger.setAttribute('aria-controls','PPSearchDialog'); trigger.setAttribute('aria-expanded','true');
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.lockPage();
      }
      this.updateViewport();
      document.documentElement.classList.add('pps-open'); this.input.focus({preventScroll:true}); this.queue();
    }
    updateViewport() {
      if (!this.dialog.open) return;
      const viewport = window.visualViewport;
      const height = viewport?.height || window.innerHeight;
      this.dialog.style.setProperty('--pps-viewport-height', `${height}px`);
      this.dialog.style.setProperty('--pps-viewport-top', `${Math.max(0, viewport?.offsetTop || 0)}px`);
      this.dialog.toggleAttribute('data-compact', height <= 520);
    }
    lockPage() {
      if (this.pageLock) return;
      const body = document.body;
      const values = {position:'fixed', top:`${-window.scrollY}px`, left:`${-window.scrollX}px`, width:'100%', overflow:'hidden'};
      this.pageLock = {x:window.scrollX, y:window.scrollY, styles:Object.keys(values).map(key => [key, body.style.getPropertyValue(key), body.style.getPropertyPriority(key)])};
      for (const [key,value] of Object.entries(values)) body.style.setProperty(key,value);
    }
    unlockPage() {
      cancelAnimationFrame(this.viewportFrame);
      if (!this.pageLock) return;
      const lock = this.pageLock;
      this.pageLock = null;
      for (const [key,value,priority] of lock.styles) {
        if (value) document.body.style.setProperty(key,value,priority);
        else document.body.style.removeProperty(key);
      }
      this.dialog.style.removeProperty('--pps-viewport-height');
      this.dialog.style.removeProperty('--pps-viewport-top');
      this.dialog.removeAttribute('data-compact');
      window.scrollTo({left:lock.x, top:lock.y, behavior:'instant'});
    }
    cancel() {
      clearTimeout(this.timer); clearTimeout(this.timeout); this.request?.abort(); this.sequence++;
      this.results.setAttribute('aria-busy','false');
    }
    queue() {
      this.cancel();
      const query = this.input.value.trim();
      this.clear.hidden = !query; this.footer.hidden = !query; this.fallback.hidden = true; this.feedback.hidden = true;
      this.results.replaceChildren(); this.status.textContent = ''; this.start.hidden = query.length >= 2;
      this.hint.hidden = query.length >= 2; this.scroller.scrollTop = 0;
      if (query.length < 2 || this.dataset.enabled !== 'true') return;
      this.status.textContent = this.dataset.loading; this.results.setAttribute('aria-busy','true');
      const sequence = this.sequence; this.timer = setTimeout(() => this.search(query,sequence),200);
    }
    async search(query,sequence) {
      const controller = new AbortController(); this.request = controller;
      let timedOut = false;
      const timeout = setTimeout(() => { timedOut=true; controller.abort(); },8000); this.timeout = timeout;
      try {
        const url = new URL(this.dataset.endpoint,location.origin);
        url.searchParams.set('q',query); url.searchParams.set('section_id','pp-search-results');
        url.searchParams.set('resources[type]','query,product,collection,article,page');
        url.searchParams.set('resources[limit]','6'); url.searchParams.set('resources[limit_scope]','each');
        url.searchParams.set('resources[options][unavailable_products]','last');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        const response = await fetch(url,{signal:controller.signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Search unavailable');
        const text = await response.text();
        if (sequence !== this.sequence || query !== this.input.value.trim() || !this.dialog.open) return;
        const content = new DOMParser().parseFromString(text,'text/html').querySelector('[data-pp-search-response]');
        if (!content) throw new Error('Search response missing');
        await this.prioritizeBestsellers(content,controller.signal);
        if (sequence !== this.sequence || query !== this.input.value.trim() || !this.dialog.open) return;
        for (const group of content.querySelectorAll('[data-pps-product-group]')) {
          if (!group.querySelector('.pps__card')) group.remove();
        }
        if (content.querySelector('.pps__card')) content.querySelector('.pps__empty')?.remove();
        if (content.dataset.ppsCollection && !content.querySelector('.pps__card')) {
          content.querySelector('.pps__empty')?.remove();
          const empty=document.createElement('p'); empty.className='pps__empty';
          empty.textContent=this.dataset.noAvailable; content.append(empty);
        }
        this.results.replaceChildren(...content.childNodes); this.status.textContent = this.dataset.updated;
      } catch (error) {
        if (sequence !== this.sequence || !this.dialog.open || (controller.signal.aborted && !timedOut)) return;
        this.results.replaceChildren(); this.fallback.hidden = false; this.status.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout); if (sequence === this.sequence) this.results.setAttribute('aria-busy','false');
      }
    }
    async prioritizeBestsellers(content,parentSignal) {
      const path=content.dataset.ppsCollection;
      const current=content.querySelector('.pps__products');
      if (!path || !current || parentSignal.aborted) return;
      for (const card of current.querySelectorAll('.pps__card')) {
        if (card.dataset.ppsAvailable === 'false' || card.querySelector('.pps__sold')) card.remove();
      }
      const request=new AbortController();
      const abort=()=>request.abort();
      parentSignal.addEventListener('abort',abort,{once:true});
      const timer=setTimeout(abort,2000);
      try {
        const url=new URL(path,location.origin);
        if (url.origin !== location.origin || !/\/collections\/[^/]+\/?$/.test(url.pathname)) return;
        url.search=''; url.hash='';
        url.searchParams.set('sort_by','best-selling');
        url.searchParams.set('filter.v.availability','1');
        url.searchParams.set('section_id','pp-search-bestsellers');
        const preview=new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        const response=await fetch(url,{signal:request.signal,headers:{Accept:'text/html'}});
        if (!response.ok) return;
        const html=await response.text();
        if (request.signal.aborted || parentSignal.aborted) return;
        const ranked=new DOMParser().parseFromString(html,'text/html').querySelector('[data-pps-bestsellers][data-pps-available-only="true"] .pps__products');
        if (ranked) {
          for (const card of ranked.querySelectorAll('.pps__card')) {
            if (card.dataset.ppsAvailable !== 'true') card.remove();
          }
          current.replaceWith(ranked);
        }
      } catch {} finally {
        clearTimeout(timer); parentSignal.removeEventListener('abort',abort);
      }
    }
    keydown(event) {
      if (event.key === 'ArrowDown' && event.target === this.input) {
        const first=this.results.querySelector('a[href]:not([tabindex="-1"])');
        if (first) { event.preventDefault(); first.focus(); }
      }
      if (event.key !== 'Tab') return;
      const controls = [...this.dialog.querySelectorAll('a[href]:not([tabindex="-1"]),button,input:not([type="hidden"])')].filter(el => !el.disabled && !el.closest('[hidden]') && getComputedStyle(el).display !== 'none');
      const first=controls[0], last=controls.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    disconnectedCallback() {
      this.cancel(); this.events?.abort(); this.toastObserver?.disconnect(); this.toastObserver=null;
      if (this.dialog?.open) this.dialog.close();
      this.unlockPage();
      document.documentElement.classList.remove('pps-open'); this.bound=false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
  const host = document.querySelector('[data-pp-shopping-app]');
  if (!host || host.dataset.initialized) return;
  host.dataset.initialized = 'true';
  const config = JSON.parse(host.querySelector('[data-pp-config]').textContent);
  const t = config.text;
  const root = config.root;
  const key = 'palettparadiset.wishlist.v1';
  const cartKey = 'palettparadiset.cart.changed.v1';
  const dialog = host.querySelector('dialog');
  const list = host.querySelector('[data-pp-list]');
  const empty = host.querySelector('[data-pp-empty]');
  const status = host.querySelector('[data-pp-status]');
  const toast = host.querySelector('[data-pp-toast]');
  let saved = [];
  let storageAvailable = true;
  let cart = { items: [], item_count: 0 };
  let busy = false;
  let version = 0;
  let openVersion = 0;
  let refreshPromise;
  let toastTimer;
  let opener;
  let drawerDirty = false;
  const cache = new Map();
  const text = (key, name = '') => (t[key] || '').replaceAll('__PRODUCT__', name);
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  const handleValid = handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle);
  const imageUrl = value => {
    if (typeof value !== 'string' || !value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopify.com')) ? url.href : '';
    } catch { return ''; }
  };
  const normalize = values => {
    if (!Array.isArray(values)) return [];
    const seen = new Set();
    return values.filter(item => item && /^\d+$/.test(String(item.id)) && handleValid(item.handle) && typeof item.title === 'string').filter(item => {
      if (seen.has(String(item.id))) return false;
      seen.add(String(item.id));
      return true;
    }).map(item => ({ id: String(item.id), handle: item.handle, title: item.title.slice(0,500), image: imageUrl(item.image) }));
  };
  function readSaved() {
    try {
      const raw = localStorage.getItem(key);
      storageAvailable = true;
      return raw ? normalize(JSON.parse(raw)) : [];
    } catch {
      storageAvailable = false;
      return saved;
    }
  }
  function tell(message) {
    const target = dialog.open ? status : toast;
    target.textContent = message;
    if (target === toast) {
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; }, 5500);
    }
  }
  function persist() {
    try {
      localStorage.setItem(key, JSON.stringify(saved));
      storageAvailable = true;
    } catch { storageAvailable = false; }
    syncHearts();
  }
  function syncHearts(scope = document) {
    const ids = new Set(saved.map(item => item.id));
    scope.querySelectorAll('[data-pp-save]').forEach(button => {
      const card = button.closest('[data-pp-product]');
      if (!card) return;
      const active = ids.has(card.dataset.ppProduct);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', text(active ? 'remove_product' : 'save_product', card.dataset.ppTitle));
      const label = button.querySelector('[data-pp-save-label]');
      if (label) label.textContent = active ? t.saved : t.save;
    });
    document.querySelectorAll('[data-pp-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-label', t.title + (saved.length ? ', ' + saved.length : ''));
    });
    document.querySelectorAll('[data-pp-count]').forEach(count => {
      count.textContent = String(saved.length);
      count.hidden = saved.length === 0;
    });
    host.querySelector('[data-pp-persistence]').textContent = storageAvailable ? t.persistence : t.storage_error;
  }
  function toggle(button) {
    const card = button.closest('[data-pp-product]');
    if (!card) return;
    const item = { id: card.dataset.ppProduct, handle: card.dataset.ppHandle, title: card.dataset.ppTitle, image: card.dataset.ppImage || '' };
    if (!normalize([item]).length) return;
    saved = readSaved();
    const exists = saved.some(entry => entry.id === item.id);
    saved = exists ? saved.filter(entry => entry.id !== item.id) : [...saved, ...normalize([item])];
    persist();
    tell(storageAvailable ? text(exists ? 'removed_notice' : 'saved_notice', item.title) : t.storage_error);
    if (dialog.open) renderList();
  }
  const plainLines = (data, id) => (data.items || []).filter(item => String(item.variant_id) === String(id) && !item.selling_plan_allocation && Object.keys(item.properties || {}).length === 0);
  const quantity = id => plainLines(cart, id).reduce((sum, item) => sum + item.quantity, 0);
  function syncCart(scope = document) {
    scope.querySelectorAll('[data-pp-quick]').forEach(control => {
      const count = quantity(control.dataset.ppQuick);
      control.hidden = false;
      const start = control.querySelector('.pp-quick-start');
      const stepper = control.querySelector('[data-pp-stepper]');
      if (start) start.hidden = count > 0;
      if (stepper) stepper.hidden = count === 0;
      const number = control.querySelector('[data-pp-quantity]');
      if (number) {
        number.textContent = String(count);
        number.setAttribute('aria-label', count + ' ' + t.in_cart);
      }
      control.setAttribute('aria-busy', String(busy));
      control.querySelectorAll('button').forEach(button => { button.disabled = busy; });
    });
    document.querySelectorAll('.cart-item-count-header--quantity, [data-cart-count-indicator]').forEach(indicator => {
      indicator.textContent = String(cart.item_count || 0);
      indicator.classList.toggle('hide', !cart.item_count);
    });
    document.querySelectorAll('.cart-count-enabled').forEach(link => link.classList.toggle('cart-count-visible', cart.item_count > 0));
  }
  async function request(path, options = {}) {
    let response;
    try { response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000), ...options }); }
    catch { throw new Error(t.network_error); }
    let body;
    try { body = await response.json(); } catch { throw new Error(t.network_error); }
    if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : t.network_error);
    return body;
  }
  async function refreshCart() {
    if (refreshPromise) return refreshPromise;
    const current = version;
    refreshPromise = request('cart.js').then(data => {
      if (current === version) { cart = data; syncCart(); }
    }).catch(() => {}).finally(() => { refreshPromise = undefined; });
    return refreshPromise;
  }
  async function change(button) {
    const control = button.closest('[data-pp-quick]');
    if (!control || busy) return;
    const id = control.dataset.ppQuick;
    const delta = Number(button.dataset.ppChange);
    if (!/^\d+$/.test(id) || ![-1, 1].includes(delta)) return;
    busy = true;
    version++;
    syncCart();
    try {
      cart = await request('cart.js');
      const before = quantity(id);
      const line = plainLines(cart, id).at(-1);
      if (delta < 0 && !line) return;
      const path = delta > 0 ? 'cart/add.js' : 'cart/change.js';
      const body = delta > 0 ? { items: [{ id, quantity: 1 }] } : { id: line.key, quantity: Math.max(0, line.quantity - 1) };
      await request(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      drawerDirty = true;
      cart = await request('cart.js');
      const after = quantity(id);
      if (after === before && delta > 0) tell(t.stock_error);
      else tell(text(delta > 0 ? 'cart_added' : 'cart_reduced', control.dataset.ppTitle));
      try { localStorage.setItem(cartKey, String(Date.now())); } catch {}
    } catch (error) {
      tell(error.message || t.network_error);
      drawerDirty = true;
      try { cart = await request('cart.js'); } catch {}
    } finally {
      busy = false;
      version++;
      syncCart();
      const next = control.querySelector('[data-pp-stepper]:not([hidden]) button:last-child') || control.querySelector('.pp-quick-start:not([hidden])');
      if (next && (document.activeElement === button || document.activeElement === document.body)) next.focus({ preventScroll: true });
    }
  }
  function element(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  }
  function makeQuick(item, product) {
    const wrapper = element('div', 'pp-quick pp-quick--list');
    wrapper.dataset.ppQuick = String(product.variants[0].id);
    wrapper.dataset.ppTitle = product.title;
    const start = element('button', 'pp-quick-start');
    start.type = 'button'; start.dataset.ppChange = '1';
    start.setAttribute('aria-label', text('add_product', product.title));
    start.append(element('span', '', t.quick_buy), element('span', 'pp-quick-symbol', '+'));
    const stepper = element('div', 'pp-quick-stepper');
    stepper.dataset.ppStepper = ''; stepper.hidden = true;
    const minus = element('button', '', '−');
    minus.type = 'button'; minus.dataset.ppChange = '-1';
    minus.setAttribute('aria-label', text('decrease', product.title));
    const number = element('span', '', '0'); number.dataset.ppQuantity = '';
    const plus = element('button', '', '+'); plus.type = 'button'; plus.dataset.ppChange = '1';
    plus.setAttribute('aria-label', text('increase', product.title));
    stepper.append(minus, number, plus); wrapper.append(start, stepper);
    return wrapper;
  }
  function renderProduct(row, item, product) {
    const details = row.querySelector('[data-pp-details]');
    details.replaceChildren();
    if (!product || product.unavailable) {
      details.append(element('p', 'pp-wish-unavailable', t.unavailable));
      return;
    }
    row.dataset.ppTitle = product.title;
    row.querySelector('[data-pp-product-title]').textContent = product.title;
    const gated = config.loginGate && (product.tags || []).some(tag => ['b2b', 'wholesale'].includes(tag.toLowerCase().replaceAll(' ', '')));
    const price = element('p', 'pp-wish-price', (product.price_varies ? t.from + ' ' : '') + new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency, maximumFractionDigits: product.price % 100 ? 2 : 0 }).format(product.price / 100));
    if (!gated) details.append(price);
    if (!product.available) {
      details.append(element('p', 'pp-wish-unavailable', t.sold_out));
      return;
    }
    if (product.variants?.length === 1 && !product.requires_selling_plan && !gated) details.append(makeQuick(item, product));
    else {
      const link = element('a', 'pp-quick-link', t.choose);
      link.href = productUrl(item.handle); details.append(link);
    }
    syncCart(row);
  }
  async function renderList() {
    const run = ++openVersion;
    const restoreIndex = Array.from(list.children).findIndex(row => row.contains(document.activeElement));
    list.replaceChildren();
    empty.hidden = saved.length > 0;
    host.querySelector('[data-pp-total]').textContent = String(saved.length);
    const items = saved.slice().reverse();
    const jobs = items.map(item => {
      const row = element('li', 'pp-wish-item');
      row.dataset.ppProduct = item.id; row.dataset.ppHandle = item.handle; row.dataset.ppTitle = item.title; row.dataset.ppImage = item.image;
      const imageLink = element('a', 'pp-wish-image'); imageLink.href = productUrl(item.handle); imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const img = element('img'); img.src = item.image; img.alt = ''; img.width = 120; img.height = 144; img.loading = 'lazy'; imageLink.append(img);
      }
      const body = element('div', 'pp-wish-item-body');
      const title = element('a', 'pp-wish-item-title', item.title); title.href = productUrl(item.handle); title.dataset.ppProductTitle = '';
      const details = element('div'); details.dataset.ppDetails = ''; details.append(element('p', 'pp-wish-loading', t.loading));
      body.append(title, details);
      const remove = element('button', 'pp-wish-remove', '×'); remove.type = 'button'; remove.dataset.ppSave = ''; remove.setAttribute('aria-pressed', 'true'); remove.setAttribute('aria-label', text('remove_product', item.title));
      row.append(imageLink, body, remove); list.append(row);
      return { row, item };
    });
    if (restoreIndex >= 0) (list.children[Math.min(restoreIndex, list.children.length - 1)]?.querySelector('[data-pp-save]') || host.querySelector('[data-pp-close]')).focus();
    let next = 0;
    await Promise.all(Array.from({ length: Math.min(4, jobs.length) }, async () => {
      while (next < jobs.length && run === openVersion) {
        const { row, item } = jobs[next++];
        try {
          let product = cache.get(item.handle);
          if (!product) {
            product = await request('products/' + encodeURIComponent(item.handle) + '.js');
            if (String(product.id) !== item.id) throw new Error(t.unavailable);
            cache.set(item.handle, product);
          }
          if (run === openVersion && row.isConnected) renderProduct(row, item, product);
        } catch {
          if (run === openVersion && row.isConnected) {
            renderProduct(row, item, { unavailable: true });
            const retry = element('button', 'pp-wish-retry', t.retry); retry.type = 'button'; retry.dataset.ppRetry = '';
            row.querySelector('[data-pp-details]').append(retry);
          }
        }
      }
    }));
  }
  function open(button) {
    opener = button;
    saved = readSaved();
    cache.clear();
    syncHearts();
    status.textContent = '';
    toast.hidden = true;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('pp-wishlist-open');
    renderList(); refreshCart();
  }
  function hydrate(scope = document) {
    syncHearts(scope); syncCart(scope);
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const openButton = target.closest('[data-pp-open]');
    const saveButton = target.closest('[data-pp-save]');
    const changeButton = target.closest('[data-pp-change]');
    if (openButton || saveButton || changeButton) {
      event.preventDefault(); event.stopPropagation();
      if (openButton) open(openButton);
      else if (saveButton) toggle(saveButton);
      else change(changeButton);
      return;
    }
    if (target.closest('[data-pp-close]')) dialog.close();
    if (target.closest('[data-pp-retry]')) { cache.clear(); renderList(); }
    if (target.closest('a.js-drawer-open-right-link') && drawerDirty && window.eventBus) {
      window.eventBus.emit('render:cart:drawer'); drawerDirty = false;
    }
  }, true);
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    openVersion++;
    document.documentElement.classList.remove('pp-wishlist-open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) {
      saved = readSaved(); syncHearts(); if (dialog.open) renderList();
    }
    if (event.key === cartKey) { drawerDirty = true; refreshCart(); }
  });
  window.addEventListener('pageshow', () => { saved = readSaved(); hydrate(); refreshCart(); });
  window.addEventListener('focus', () => { saved = readSaved(); syncHearts(); refreshCart(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCart(); });
  document.addEventListener('shopify:section:load', event => hydrate(event.target));
  const observer = new MutationObserver(records => {
    const roots = new Set();
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1 && !host.contains(node) && (node.matches('[data-pp-product], [data-pp-open]') || node.querySelector('[data-pp-product], [data-pp-open]'))) roots.add(node.parentElement || node);
    }
    roots.forEach(scope => hydrate(scope));
  });
  observer.observe(document.body, { childList: true, subtree: true });
  function connectTheme() {
    if (!window.eventBus) return;
    window.eventBus.on('update:cart:drawer', data => {
      version++;
      if (data?.items) { cart = data; syncCart(); }
      else refreshCart();
    });
    window.eventBus.on('open:cart:drawer', () => refreshCart());
  }
  saved = readSaved();
  hydrate();
  document.documentElement.classList.add('pp-shopping-ready');
  refreshCart();
  if (document.readyState === 'complete') connectTheme();
  else window.addEventListener('load', connectTheme, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
